import { create } from 'zustand'

const leagueInvitationStoreStates = (set: any) => ({
  inviteModal: false,
  setInviteModal: (state: boolean) =>
    set(() => ({
      inviteModal: state,
    })),

  selectedOrgsIds: [],
  setSelectedOrgsIds: (state: string[]) =>
    set(() => ({
      selectedOrgsIds: state,
    })),
})

export const leagueInvitationStore = create(leagueInvitationStoreStates)
